/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Openlauncher_Play1Inputs */

const id_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mainkan`)
};

const ms_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main`)
};

const da_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spil`)
};

const de_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielen`)
};

const en_us2_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play`)
};

const es_es2_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jugar`)
};

const es_mx2_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jugar`)
};

const fil_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laruin`)
};

const fr_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouer`)
};

const it_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gioca`)
};

const hu_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Játék`)
};

const nl_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spelen`)
};

const no_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spill`)
};

const pl_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graj`)
};

const pt_br2_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play`)
};

const pt_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogar`)
};

const ro_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joacă`)
};

const fi_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelaa`)
};

const sv_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spela`)
};

const vi_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chơi`)
};

const tr_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyna`)
};

const cs_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hrát`)
};

const bg_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игра`)
};

const ru_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Играть`)
};

const uk_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Грати`)
};

const ar_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لعب`)
};

const hi_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खेलें`)
};

const th_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เล่น`)
};

const ja_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレイ`)
};

const zh_cn2_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play`)
};

const zh_hant1_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play`)
};

const ko_components_openlauncher_play1 = /** @type {(inputs: Components_Openlauncher_Play1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play`)
};

/**
* | output |
* | --- |
* | "Play" |
*
* @param {Components_Openlauncher_Play1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_openlauncher_play1 = /** @type {((inputs?: Components_Openlauncher_Play1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Openlauncher_Play1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_openlauncher_play1(inputs)
	if (locale === "ms") return ms_components_openlauncher_play1(inputs)
	if (locale === "da") return da_components_openlauncher_play1(inputs)
	if (locale === "de") return de_components_openlauncher_play1(inputs)
	if (locale === "en-US") return en_us2_components_openlauncher_play1(inputs)
	if (locale === "es-ES") return es_es2_components_openlauncher_play1(inputs)
	if (locale === "es-MX") return es_mx2_components_openlauncher_play1(inputs)
	if (locale === "fil") return fil_components_openlauncher_play1(inputs)
	if (locale === "fr") return fr_components_openlauncher_play1(inputs)
	if (locale === "it") return it_components_openlauncher_play1(inputs)
	if (locale === "hu") return hu_components_openlauncher_play1(inputs)
	if (locale === "nl") return nl_components_openlauncher_play1(inputs)
	if (locale === "no") return no_components_openlauncher_play1(inputs)
	if (locale === "pl") return pl_components_openlauncher_play1(inputs)
	if (locale === "pt-BR") return pt_br2_components_openlauncher_play1(inputs)
	if (locale === "pt") return pt_components_openlauncher_play1(inputs)
	if (locale === "ro") return ro_components_openlauncher_play1(inputs)
	if (locale === "fi") return fi_components_openlauncher_play1(inputs)
	if (locale === "sv") return sv_components_openlauncher_play1(inputs)
	if (locale === "vi") return vi_components_openlauncher_play1(inputs)
	if (locale === "tr") return tr_components_openlauncher_play1(inputs)
	if (locale === "cs") return cs_components_openlauncher_play1(inputs)
	if (locale === "bg") return bg_components_openlauncher_play1(inputs)
	if (locale === "ru") return ru_components_openlauncher_play1(inputs)
	if (locale === "uk") return uk_components_openlauncher_play1(inputs)
	if (locale === "ar") return ar_components_openlauncher_play1(inputs)
	if (locale === "hi") return hi_components_openlauncher_play1(inputs)
	if (locale === "th") return th_components_openlauncher_play1(inputs)
	if (locale === "ja") return ja_components_openlauncher_play1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_openlauncher_play1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_openlauncher_play1(inputs)
	return ko_components_openlauncher_play1(inputs)
});
export { components_openlauncher_play1 as "components.openLauncher.play" }